<template>
  <div id="courseInfoList">
    <div class="background-white first-title" >
      <span class="title">培训课程管理</span>
       <!-- <el-select v-if="branchtypeLst.length>0"  v-model="branchtype" placeholder="请选择渠道" style="width:30%;float:right" @change="changeBranchtype()">
          <el-option  v-for="(branchtype,index) in branchtypeLst" :key="index" :label="branchtype.name" :value="branchtype.code"></el-option>
        </el-select> -->
    </div>
    <div class="item">
        <div class="item-title">筛选条件</div>
        <div  class="background-white">
        <el-form  ref="test123"  label-width="75px">
          <el-row :gutter="20">
            <el-col :span="6">
                <el-popover
                    placement="bottom"
                    min-width=100
                    trigger="click"
                    v-model="selectTreeVisible"
                    >
                    <div class="editorDialog-tree-div">
                      <el-tree
                      :data="dirMenuTree"
                      :props="menuTreeProps"
                      @node-click="setDirLocation"
                      ref="dirMenuTree"
                      node-key="dirCode"
                      :highlight-current=true
                      :expand-on-click-node="false">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span> {{ node.label }}</span>
                      </span>
                      </el-tree>
                    </div>
                      <el-form-item label="课程目录" slot="reference" >
                      <el-input v-model="dirCodeStr"  readonly="readonly"></el-input>
                    </el-form-item>
                </el-popover>
            </el-col>
            <el-col :span="6">
              <el-form-item label="上传人"   >
                <el-select v-model="searchDto.uploaderCode" placeholder="请选择">
                  <el-option
                    v-for="item in courseUploadLst"
                    :key="item.uploaderCode"
                    :label="item.uploaderName"
                    :value="item.uploaderCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="课程状态"   >
                <el-select v-model="searchDto.courseState" placeholder="请选择">
                  <el-option   label="全部" value=""> </el-option>
                  <el-option   label="有效" value=0> </el-option>
                  <el-option   label="失效" value=1> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="6" style="text-align:right">  <el-button type="primary" @click="search()" class="search-btn">筛选</el-button></el-col>
          </el-row>
        </el-form>

        </div>
    </div>

    <div class="item">

        <div class="item-title">搜索</div>

        <div  class="background-white">
           <el-input v-model="searchDto.courseName" style="width:60%" placeholder="模糊搜索课程名"></el-input>
           <el-button type="primary" @click="fuzzySearch()" class="search-btn">查询</el-button>
        </div>
    </div>
    <div class="item">

        <div class="item-title" style="padding-right: 0;">课件列表
          <el-button type="primary" @click="dialogShow()" class="search-btn">新增课程</el-button>
          <el-button type="primary" @click="delCourse()" class="search-btn" :disabled="batchShow">删除所选课程</el-button>
          <el-button type="primary" @click="batchTabState(1)" class="search-btn" :disabled="batchShow">批量生效</el-button>
          <el-button type="primary" @click="batchTabState(2)" class="search-btn" :disabled="batchInvalid">批量失效</el-button>
        </div>
        <div  class="background-white">
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
                   <el-table-column
                    type="selection"
                    width="30">
                  </el-table-column>
                  <el-table-column
                    type="index"
                    width="40">
                  </el-table-column>
                  <el-table-column
                    prop="courseName"
                    label="课程名称"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="dirInfo"
                    label="课程目录"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="courseSize"
                    label="文件大小"
                    :formatter=getCourseSizeStr
                    align="center">
                  </el-table-column>
                   <el-table-column
                    prop="uploaderName"
                    label="上传人"
                    align="center">
                  </el-table-column>
                   <el-table-column
                     :formatter=timeFormer
                    label="上传时间"
                    align="center">
                  </el-table-column>
                  <el-table-column
                     :formatter=getCourseStateStr
                    label="课程状态"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                  >

                  <template slot-scope="scope">

                      <el-button type="text"  v-if="scope.row.courseState ==0 && scope.row.isAssigned !=0"   size="small"  @click="updateCourseInfo(scope.row.courseCode,'2')" >推送该课程为阅读任务</el-button>
                      <el-button type="text"   v-if="scope.row.courseState ==1" size="small"  @click="dialogShow(scope.row.courseCode,scope.row.dirInfo)">编辑内容</el-button>
                      <el-button type="text"  size="small"  @click="updateCourseInfo(scope.row.courseCode,'1',scope.row.courseState)">{{scope.row.courseState ==0?'失效':'有效'}}</el-button>
                      <el-button type="text"  v-if="scope.row.courseState ==1"  size="small"  @click="delCourse(scope.row.courseCode)">删除</el-button>
                  </template>
                  </el-table-column>
                </el-table>
                 <div style="text-align:right">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next, jumper"
                            :page-sizes="[10, 20, 50]"
                            :total="records">
                    </el-pagination>
                </div>
        </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form  ref="form" label-width="80px" style="     overflow-x: hidden;max-height: 400px;">
        <el-form-item label="课程名称"  >
          <el-input :class="{error:errors.has('courseName')}" v-model="courseInfo.courseName"   name="courseName" v-validate="'required'"  placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-popover
            placement="bottom"
            trigger="click"
            v-model="selectDirCodeVisible"
            popper-class="courseInfoList-pop-class"
            >
            <div class="editorDialog-tree-div">
              <el-tree
              :data="dirCodeTree"
              :props="menuTreeProps"
              @node-click="setDirCodeNode"
              ref="dirCodeTree"
              node-key="dirCode"
              :highlight-current=true
              :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span> {{ node.label }}</span>
              </span>
              </el-tree>
            </div>
              <el-form-item label="课程地址" slot="reference" >
              <el-input  :class="{error:errors.has('dirCodeUpdStr')}" v-model="dirCodeUpdStr"  readonly="readonly" v-validate="'required'" name="dirCodeUpdStr" placeholder="请选择课程地址"></el-input>
            </el-form-item>
        </el-popover>
        <el-row  style="    margin-bottom: 10px;">
          <el-col :span="12">
            <div class="dialog-left">
                <h4>课程上传</h4>
                <el-upload
                  class="upload-demo"
                  :action= "uploadUrl"
                  :data="uploadData"
                  ref="uploadFile"
                  :on-success="uploadSuccess"
                  :on-error="uploadError"
                  :before-upload="beforeAvatarUploadFile"
                  :headers="uploadHeader"
                >
                 <el-button type="primary"   >点击上传课件文件</el-button>

              </el-upload>
              <div class="tip" > 仅支持xls,pdf,word,ppt格式，文件大小≤5M
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-right">
                <h4>音频上传</h4>
                 <div class="tip" >
                    仅支持MP3格式，文件大小≤5M，可选择是否上传，上传的音频文件与课件对应，一个课件文件只能与一个音频文件对应
                    </div>
            </div>
          </el-col>
        </el-row>
         <el-row :gutter="20" v-for="(courseWare,index) in courseWareLst" :key="index" v-if="courseWare.modifyFlag !='2'">
          <el-col :span="12" >
            <div class="upload-div"   >
              <div :class="{'upload-info':true,'fileActive':fileActive == index}"  @mouseover="fileActive=index" @mouseout="fileActive=-1">
                <div class="upload-type">
                   <img src="../../../assets/train/txt_icon.png"/>
                </div>
                <div class="upload-name">
                  {{courseWare.fileName}}
                  <el-upload
                        class="upload-demo change-upload"
                        :action= "uploadUrl"
                        :data="uploadData"
                        :ref="'changeUploadFile'+index"
                        :on-success="( res, file)=> uploadFileSuccess(index, res, file)"
                         :on-error="uploadError"
                        :headers="uploadHeader"
                         :before-upload="beforeAvatarUploadFile"
                        >
                        <a  style="float:right" v-if="fileActive==index"  >  更换课件</a>
                      </el-upload>
                  </div>
                <div class="upload-status" v-if="fileActive!=index">
                  <img src="../../../assets/train/upload_finished.png"/>
                </div>
                <div class="upload-status-10" @click="delFile(index)" v-else>
                  <img src="../../../assets/train/del.png"/>
                </div>
                <div style="clear:both"></div>
              </div>
              <div style="margin-left: 10%; width: 50%;" >
                 <el-input v-model="courseWare.prescribedDuration" placeholder="请输入预期学习时长" :class="{error:errors.has('prescribedDuration'+index)}" :name="'prescribedDuration'+index" v-validate="'num'" @change="changePrescribedDuration(index)"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-right">
                <div class="upload-div" v-if="courseWare.audioPath != null && courseWare.audioPath != ''">

                  <div :class="{'upload-info':true,'fileActive':audioActive == index}"  @mouseover="audioActive=index" @mouseout="audioActive=-1">
                    <div class="upload-type">
                      <img src="../../../assets/train/mp3_icon.png"/>
                    </div>
                    <div class="upload-name">
                      {{courseWare.audioName}}
                      <el-upload
                        class="upload-demo change-upload"
                        :action= "uploadUrl"
                        :data="uploadAudio"
                        :ref="'changeUploadAudio'+index"
                        :on-success="( res, file)=> uploadAudioSuccess(index, 1,res, file)"
                        :on-error="uploadError"
                        :headers="uploadHeader"
                         :before-upload="beforeAvatarUploadAudio"
                        >
                        <a  style="float:right" v-if="audioActive==index"  > 更换音频</a>
                      </el-upload>

                    </div>

                    <div class="upload-status" v-if="audioActive!=index">
                      <img src="../../../assets/train/upload_finished.png"/>
                    </div>
                    <div class="upload-status-10" @click="delAudio(index)" v-else>
                      <img src="../../../assets/train/del.png"/>
                    </div>
                     <div style="clear:both"></div>
                  </div>

                </div>
                <div class="upload-div"  v-else>
                  <el-upload
                    class="upload-demo"
                    :action= "uploadUrl"
                    :data="uploadAudio"
                    :ref="'uploadAudio'+index"
                    :on-success="( res, file)=> uploadAudioSuccess(index,2, res, file)"
                     :on-error="uploadError"
                     :before-upload="beforeAvatarUploadAudio"
                    :headers="uploadHeader"
                    >
                  <el-button type="primary" style="margin-top:10px"  >点击上传音频文件</el-button>
                </el-upload>
              </div>
            </div>
          </el-col>
        </el-row>
          <el-row  style="margin-top:10px">
             <el-input type="textarea" v-model="courseInfo.description" placeholder="请输入课程介绍"></el-input>
         </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCourse()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/modules/api.js'
import Vue from 'vue'
import date from '@/filters/date.js'
import localStorage from '@/components/cache/localStorage'
import sessionStorage from '@/components/cache'
import VeeValidate, { Validator } from 'vee-validate'
import getIP from '@/components/utils/getIP'
// 提示语汉化
Validator.locale = 'zh_CN'
Vue.use(VeeValidate, {
  events: 'blur'
})
// 提示语汉化
Validator.locale = 'zh_CN'
// 手机号校验规则
Validator.extend('num', {
  getMessage: field => field + '格式不正确',
  validate: value => {
    return /^\d+(\.\d+)?$/.test(value)
  }
})

export default {
  data () {
    return {
      batchShow: false,
      batchInvalid: false,
      checkedBatch: [],
      checkedBatchCode: [],
      // 剩余时间
      uploadUrl: process.env.UPLOAD_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/upload',
      dialogFormVisible: false,
      selectDirCodeVisible: false, // 文件目录
      dialogTitle: '编辑课程',
      branchtypeLst: [], // 渠道列表
      courseUploadLst: [], // 上传人列表
      menuTreeProps: {
        children: 'childDir',
        label: 'dirName',
        id: 'dirCode'
      }, // 菜单树配置
      selectTreeVisible: false,
      dirMenuTree: [],
      branchtype: '',
      searchDto: {
        uploaderCode: '',
        dirCode: '',
        courseState: '',
        courseName: ''
      },
      searchVo: {
        uploaderCode: '',
        dirCode: '',
        courseState: '',
        courseName: ''
      },
      dirCodeStr: '',
      pageSize: 10,
      currentPage: 1,
      records: 0, // 总条数
      tableData: [],
      courseInfo: {
        courseCode: '',
        courseName: '',
        description: ''
      },
      courseWareLst: [],
      uploadHeader: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionStorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.session_get('username')
      },
      uploadData: {
        'domain': 'TRAIN',
        'buz': 'FILE',
        'expired': -1,
        'actions': '',
        'buzId': '123',
        'auth': 1
      },
      uploadAudio: {
        'domain': 'TRAIN',
        'buz': 'AUDIO',
        'expired': -1,
        'actions': '',
        'buzId': '123',
        'auth': 1
      },
      fileActive: -1,
      audioActive: -1,
      dirCodeUpdStr: '',
      courseCodeLst: [], // 删除集合
      dirCodeTree: [], // 修改弹出框中的目录树
      courseObjLst: [],
      fileTypes: ['application/msword', 'application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
      audioTypes: ['audio/mpeg', 'audio/mp3']
    }
  },
  mounted () {
    this.getBranchtypeLst()
  },
  methods: {
    changeBranchtype () {
      this.initPage()
    },
    // 除了渠道，整个页面的初始化
    initPage () {
      this.getMenuDirTree()
      this.getCourseUploaderByBranchtype()
      this.dirCodeStr = '全部'
      // 初始化参数
      this.searchDto = {
        uploaderCode: '',
        dirCode: '',
        courseState: '',
        courseName: ''
      }
      this.searchVo = {
        uploaderCode: '',
        dirCode: '',
        courseState: '',
        courseName: ''
      }
      this.getCourseInfoWithPage()
    },
    // 查询，每页条数更改
    handleSizeChange: function (size) {
      this.pageSize = size
      this.getCourseInfoWithPage()
    },
    // 当前页数更改
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage
      this.getCourseInfoWithPage()
    },
    handleSelectionChange: function (val) {
      this.courseObjLst = val
      this.checkedBatch = []
      this.checkedBatchCode = []
      for (let i = 0; i < val.length; i++) {
        this.checkedBatchCode.push(val[i].courseCode)
        this.checkedBatch.push(val[i].courseState)
      }
    },
    // 获取查询课程目录
    getMenuDirTree () {
      let that = this
      api.getDirTree({}, function (res) {
        that.dirMenuTree = []
        if (res.result.isSuccess === true) {
          let dirMenuTree = {'dirCode': '', 'dirName': '全部', 'childDir': []}
          dirMenuTree.childDir = res.data
          that.dirMenuTree.push(dirMenuTree)
          that.dirCodeTree = res.data
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 选中目录
    setDirLocation (data) {
      let dirCodeLst = []
      let node = this.$refs.dirMenuTree.getNode(data.dirCode)
      dirCodeLst.push(node.data.dirName)
      while (node.level > 1) {
        dirCodeLst.push(node.parent.data.dirName)
        node = this.$refs.dirMenuTree.getNode(node.parent.data.dirCode)
      }
      dirCodeLst = dirCodeLst.reverse()
      this.dirCodeStr = dirCodeLst.join('>')
      this.selectTreeVisible = false
      this.searchDto.dirCode = data.dirCode
    },
    // 修改弹出框选中目录
    setDirCodeNode (data) {
      let dirCodeLst = []
      let node = this.$refs.dirCodeTree.getNode(data.dirCode)
      dirCodeLst.push(node.data.dirName)
      while (node.level > 1) {
        dirCodeLst.push(node.parent.data.dirName)
        node = this.$refs.dirCodeTree.getNode(node.parent.data.dirCode)
      }
      dirCodeLst = dirCodeLst.reverse()
      this.dirCodeUpdStr = dirCodeLst.join('>')
      this.selectDirCodeVisible = false
      this.courseInfo.dirCode = data.dirCode
      this.errors.remove('dirCodeUpdStr')
    },
    // 获取渠道列表
    getBranchtypeLst () {
      let that = this
      api.getBranchtypeLst({}, function (res) {
        if (res.result.isSuccess === true) {
          that.branchtypeLst = res.data

          if (that.branchtypeLst.length === 0) {
            that.branchtype = 'SYSADMIN'
          } else {
            that.branchtype = res.data[0].code
          }
          that.initPage()
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 获取表格数据
    getCourseInfoWithPage () {
      let that = this
      let reqDto = {}
      for (var key in that.searchVo) {
        if (that.searchVo[key] !== '') {
          reqDto[key] = that.searchVo[key]
        }
      }
      reqDto.branchtype = that.branchtype
      reqDto.pageSize = that.pageSize
      reqDto.page = that.currentPage

      that.tableData = []
      api.getCourseInfoWithPage(reqDto, function (res) {
        if (res.result.isSuccess === true) {
          that.tableData = res.data.data
          that.records = res.data.records
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 查询
    search () {
      this.currentPage = 1
      this.searchDto.courseName = ''
      this.searchVo = JSON.parse(JSON.stringify(this.searchDto))

      this.getCourseInfoWithPage()
    },
    // 模糊查询
    fuzzySearch () {
      this.currentPage = 1
      this.searchDto.dirCode = ''
      this.searchDto.uploaderCode = ''
      this.searchDto.courseState = ''
      this.dirCodeStr = '全部'
      this.searchVo.courseName = this.searchDto.courseName
      this.searchVo = JSON.parse(JSON.stringify(this.searchDto))
      this.getCourseInfoWithPage()
    },
    // 获取上传人列表
    getCourseUploaderByBranchtype () {
      let that = this
      api.getCourseUploaderByBranchtype({'branchtype': that.branchtype}, function (res) {
        if (res.result.isSuccess === true) {
          that.courseUploadLst = res.data
          let obj = {
            uploaderName: '全部',
            uploaderCode: ''
          }
          that.courseUploadLst.splice(0, 0, obj)
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 表格显示，时间
    timeFormer (row) {
      if (row.uploadTime != null) {
        return date.formatDate(row.uploadTime, 'yyyy.MM.dd hh:mm:ss')
      }
    },
    // 表格显示，状态
    getCourseStateStr (row) {
      if (row.courseState != null) {
        if (row.courseState === 0) {
          return '有效'
        } else if (row.courseState === 1) {
          return '失效'
        }
      }
    },
    getCourseSizeStr (row) {
      return (row.courseSize / 1024).toFixed(2) + 'M'
    },
    dialogShow (courseCode, dirCodeInfo) {
      let that = this
      that.dirCodeUpdStr = ''
      that.courseWareLst = []
      that.courseInfo = {}
      that.dirCodeUpdStr = ''
      that.errors.clear()
      if (courseCode == null) {
        // 新增
        that.updCode = ''
      } else {
        // 修改
        that.updCode = courseCode
        api.getCourseByCode({'courseCode': courseCode}, function (res) {
          if (res.result.isSuccess === true) {
            that.courseWareLst = res.data.courseWareLst
            that.courseInfo = res.data.courseInfo
            that.dirCodeUpdStr = dirCodeInfo
            that.$refs.dirCodeTree.setCurrentKey(res.data.courseInfo.dirCode)
          } else {
            that.$message.error(res.result.error)
          }
        })
      }
      that.dialogFormVisible = true
    },
    /**
     * 课件上传成功后操作
     */
    uploadSuccess (res, file) {
      let that = this
      if (res.result.isSuccess === true) {
        that.$refs.uploadFile.clearFiles()
        let courseWare = {
          fileSize: parseInt(file.size / 1024), // kB
          filePath: api.urlDomin + res.data.fileId + '.' + res.data.ext,
          fileName: file.name,
          modifyFlag: '0',
          audioPath: '',
          audioSize: 0,
          audioName: ''
        }
        that.courseWareLst.push(courseWare)
      } else {
        that.$message.error(res.result.error)
        that.$refs.uploadFile.clearFiles()
      }
    },
    uploadError (error) {
      console.log(error)
      this.$message.error('上传失败')
    },
    beforeAvatarUploadFile (file) {
      if (this.fileTypes.indexOf(file.type) === -1) {
        this.$message.error('不支持此文件格式呦~')
        return false
      } else if (file.size > 5 * 1024 * 1024) {
        this.$message.error('此文件大小超过5M了呦~')
        return false
      } else {
        return true
      }
    },
    beforeAvatarUploadAudio (file) {
      if (this.audioTypes.indexOf(file.type) === -1) {
        this.$message.error('不支持此文件格式呦~')
        return false
      } else if (file.size > 5 * 1024 * 1024) {
        this.$message.error('此文件大小超过5M了呦~')
        return false
      } else {
        return true
      }
    },
    /**
     * 课件上传修改成功后操作
     */
    uploadFileSuccess (index, res, file) {
      let that = this
      if (res.result.isSuccess === true) {
        that.$refs['changeUploadFile' + index][0].clearFiles()
        that.courseWareLst[index].filePath = api.urlDomin + res.data.fileId + '.' + res.data.ext
        that.courseWareLst[index].fileSize = parseInt(file.size / 1024)
        that.courseWareLst[index].fileName = file.name
        if (that.courseWareLst[index].modifyFlag !== '0' && that.courseWareLst[index].modifyFlag !== '2') {
          that.courseWareLst[index].modifyFlag = '3'
        }
      } else {
        that.$refs['changeUploadFile' + index][0].clearFiles()
        that.$message.error(res.result.error)
      }
    },
    // modifyFlag: 0-新增  1-修改  2- 删除 3-修改课件
    uploadAudioSuccess (index, flag, res, file) {
      let that = this
      if (res.result.isSuccess === true) {
        that.courseWareLst[index].audioPath = api.urlDomin + res.data.fileId + '.' + res.data.ext
        that.courseWareLst[index].audioSize = parseInt(file.size / 1024)
        that.courseWareLst[index].audioName = file.name
        if (that.courseWareLst[index].modifyFlag == null) {
          that.courseWareLst[index].modifyFlag = '1'
        }
        if (flag === 1) {
          that.$refs['changeUploadAudio' + index][0].clearFiles()
        } else {
          that.$refs['uploadAudio' + index][0].clearFiles()
        }
      } else {
        if (flag === 1) {
          that.$refs['changeUploadAudio' + index][0].clearFiles()
        } else {
          that.$refs['uploadAudio' + index][0].clearFiles()
        }
        that.$message.error(res.result.error)
      }
    },
    /**
     * 删除音频
     */
    delAudio (index) {
      this.courseWareLst[index].audioPath = ''
      this.courseWareLst[index].audioSize = ''
      this.courseWareLst[index].audioName = ''
      if (this.courseWareLst[index].modifyFlag == null) {
        this.courseWareLst[index].modifyFlag = '1'
      }
    },
    /**
     * 删除课件
     */
    delFile (index) {
      this.$confirm('此操作将删除该课件及对应音频, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.courseWareLst[index].modifyFlag = '2'
      }).catch(() => {
      })
    },
    /**
     *修改预期学时后的操作
     */
    changePrescribedDuration (index) {
      if (this.courseWareLst[index].modifyFlag == null) {
        this.courseWareLst[index].modifyFlag = '1'
      }
    },
    /**
     * 保存课程按钮
     */
    saveCourse () {
      let that = this
      that.$validator.validateAll().then((result) => {
        if (result) {
          let courseWareLst = JSON.parse(JSON.stringify(that.courseWareLst))
          for (var i = 0; i < courseWareLst.length; i++) {
            if (courseWareLst[i].modifyFlag === '3') {
              let newcourse = JSON.parse(JSON.stringify(courseWareLst[i]))
              newcourse.fileCode = null
              newcourse.modifyFlag = '0'
              courseWareLst.push(newcourse)

              courseWareLst[i].modifyFlag = '2'
            } else if (courseWareLst[i].modifyFlag === '2' && (courseWareLst[i].fileCode == null || courseWareLst[i].fileCode === '')) {
              courseWareLst.splice(i, 1)
              i--
            }
          }
          that.courseInfo.branchtype = that.branchtype
          let req = JSON.parse(JSON.stringify(that.courseInfo))
          req.courseWareLst = courseWareLst
          // 执行保存操作，成功关闭弹出，更新表格
          if (that.updCode === '') {
            // 增加
            api.saveCourse(req, function (res) {
              if (res.result.isSuccess === true) {
                that.dialogFormVisible = false
                that.selectDirCodeVisible = false
                that.getCourseInfoWithPage()
              } else {
                that.$message.error(res.result.error)
              }
            })
          } else {
            // 修改
            api.updateCourse(req, function (res) {
              if (res.result.isSuccess === true) {
                that.dialogFormVisible = false
                that.selectDirCodeVisible = false
                that.getCourseInfoWithPage()
              } else {
                that.$message.error(res.result.error)
              }
            })
          }
        }
      })
    },
    /**
     * 删除课程
     */
    delCourse (delCourseCode) {
      let that = this
      that.$confirm('此操作将永久删除该课程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let courseCodeLst = []
        if (delCourseCode == null) {
          for (var i = 0; i < that.courseObjLst.length; i++) {
            courseCodeLst.push(that.courseObjLst[i].courseCode)
          }
        } else {
          courseCodeLst.push(delCourseCode)
        }
        if (courseCodeLst.length === 0) {
          that.$message.error('请选择要删除的项目')
        } else {
          let req = {
            courseCodeLst: courseCodeLst
          }
          api.delCourse(req, function (res) {
            if (res.result.isSuccess === true) {
              that.currentPage = 1
              that.getCourseInfoWithPage()
              that.$message.success('删除成功')
            } else {
              that.$message.error(res.result.error)
            }
          })
        }
      })
    },
    /**
     * 推送，失效按钮
     */
    updateCourseInfo (courseCode, flag, courseState) {
      // flag 1-失效状态  2-推送
      let that = this
      let msg = ''
      var req = {
        courseCode: courseCode
      }
      if (flag === '1') {
        if (courseState === 0) {
          req.courseState = 1
          msg = '此操作将在前端不显示该课程, 是否继续?'
        } else {
          req.courseState = 0
          msg = '此操作将在前端显示该课程, 是否继续?'
        }
        that.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.updateCourseInfo(req, function (res) {
            if (res.result.isSuccess === true) {
              that.getCourseInfoWithPage()
              that.$message.success('设置成功')
            } else {
              that.$message.error(res.result.error)
            }
          })
        })
      } else {
        req.isAssigned = 0
        api.updateCourseInfo(req, function (res) {
          if (res.result.isSuccess === true) {
            that.getCourseInfoWithPage()
            that.$message.success('设置成功')
          } else {
            that.$message.error(res.result.error)
          }
        })
      }
    },
    batchTabState (state) {
      let that = this
      let req = {
        courseState: state,
        courseList: this.checkedBatchCode
      }
      api.post(this.$url.batchTabState, req, function (res) {
        console.log(res)
        if (res.result.isSuccess === true) {
          that.getCourseInfoWithPage()
          that.$message.success('设置成功')
        } else {
          that.$message.error(res.result.error)
        }
      })
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal.name === 'courseInfoList') {
          this.currentPage = 1
          this.getBranchtypeLst()
        }
      }
    },
    'checkedBatch': {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        console.log(newVal)
        if (newVal.length === 0) {
          this.batchInvalid = true
          this.batchShow = true
        } else {
          if (newVal.indexOf(0) < 0) {
            // 全选 失效
            this.batchInvalid = true
            this.batchShow = false
          } else if (newVal.indexOf(1) < 0) {
            // 全选 生效
            this.batchInvalid = false
            this.batchShow = true
          } else {
            // 混合选择 无显示
            this.batchInvalid = true
            this.batchShow = true
          }
        }
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
 .title{
   font-size:16px;
   font-weight:900
 }
.background-white .el-form-item{
  margin-bottom: 0
}
.editorDialog-tree-div{
    height: 200px;
    overflow: auto;
}
 .background-white{
   background-color: #fff;
   padding:10px 1%
 }
 .item{
   margin-top: 10px;
 }
 .item-title{
  background-color: #eee;
        padding: 5px 2%;
    height: 40px;
    line-height: 40px;
 }
 .search-btn{
    float: right;
    margin-right: 1%;

 }
 .upload-type{
   float: left;
    height:20px;
    margin-right: 1%;
 }
 .upload-type img{
    height: 100%;
 }
 .upload-name{
   float: left;
   width: 80%;
 }
 .upload-status{
  float: left;
   height:15px;
 }
 .upload-status-10{
   float: left;
 height:10px;
 }
 .upload-status img,.upload-status-10 img{
    height: 100%;
 }
 .tip{
   font-size: 12px;
   color:#9E9E9E;
 }
.first-title{
  padding: 10px 2%;
  height: 40px;
  line-height: 40px
}
.fileActive{
  background-color:#8b8e91;
  color: #fff;
}

.change-upload{
 float: right;
  margin-right: 5%;
}
.upload-info{
  margin-top: 10px;
  padding: 5px 3%;
}

</style>
<style>
.courseInfoList-pop-class{
  width:30%;
  margin-left:5%
}
#courseInfoList .error input{
  border-color:red
}
</style>



// WEBPACK FOOTER //
// src/pages/course/backend/courseInfoList.vue